module.exports = __webpack_public_path__ + "img/meter.78bfbc7c.png";